import { ValidationIndustryStatus, ValidationTaxIdStatus } from 'commons/enums';

export function getDeniedTranslationKeys(
  statusDetail?: string,
  hasBalance?: boolean,
) {
  switch (statusDetail) {
    case ValidationIndustryStatus.PROHIBITED:
    case ValidationIndustryStatus.RESTRICTED:
      return {
        titleKey: 'prohibitedIndustry.title',
        descriptionKey: hasBalance
          ? 'prohibitedIndustry.descriptionWithBalance'
          : 'prohibitedIndustry.descriptionNoBalance',
      };

    case ValidationTaxIdStatus.INVALID:
      return {
        titleKey: 'invalidTaxId.title',
        descriptionKey: 'invalidTaxId.description',
      };

    default:
      return {
        titleKey: 'generic.title',
        descriptionKey: 'generic.description',
      };
  }
}
